/* ==========================================================================
   AMENDOPRO HEADER - STICKY HEADER JS
   ========================================================================== */

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

/* ==========================================================================
   HOVER MENU - Abre dropdowns no hover (desktop)
   ========================================================================== */

(function() {
  var isDesktop = window.matchMedia('(min-width: 990px)');

  function initHoverMenu() {
    if (!isDesktop.matches) return;

    var header = document.querySelector('.header');
    if (!header) return;

    // Only target desktop nav details, NOT the mobile drawer
    var allDetails = header.querySelectorAll('.header__inline-menu details');

    allDetails.forEach(function(detail) {
      var closeTimeout;
      var hoverTimeout;
      var summary = detail.querySelector('summary');
      var summaryLink = summary ? summary.querySelector('a') : null;
      var openedByHover = false;

      if (summary) {
        summary.addEventListener('click', function(e) {
          // Prevent browser default details toggle
          e.preventDefault();
          e.stopPropagation();

          var hasHover = window.matchMedia('(hover: hover)').matches;
          var href = this.getAttribute('data-href');

          if (hasHover && href && href !== '#') {
            window.location.href = href;
            return;
          }

          if (openedByHover) {
            // Keep open if it was just opened by hover (handles touch devices)
            detail.setAttribute('open', '');
            openedByHover = false;
            return;
          }

          // Toggle open state
          var isOpen = detail.hasAttribute('open');
          if (isOpen) {
            detail.removeAttribute('open');
          } else {
            // Close other open submenus
            allDetails.forEach(function(d) {
              d.removeAttribute('open');
            });
            detail.setAttribute('open', '');
          }
        });
      }

      detail.addEventListener('mouseenter', function() {
        clearTimeout(closeTimeout);
        clearTimeout(hoverTimeout);
        openedByHover = true;

        // Close other submenus
        allDetails.forEach(function(d) {
          if (d !== detail) d.removeAttribute('open');
        });
        detail.setAttribute('open', '');

        // Reset hover flag after 500ms so manual clicks can still toggle
        hoverTimeout = setTimeout(function() {
          openedByHover = false;
        }, 500);
      });

      detail.addEventListener('mouseleave', function() {
        clearTimeout(hoverTimeout);
        openedByHover = false;
        var el = detail;
        closeTimeout = setTimeout(function() {
          el.removeAttribute('open');
        }, 150);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenu);
  } else {
    initHoverMenu();
  }

  isDesktop.addEventListener('change', function() {
    if (isDesktop.matches) {
      initHoverMenu();
    } else {
      var details = document.querySelectorAll('.header__inline-menu details');
      details.forEach(function(d) {
        d.open = false;
      });
    }
  });

  // Intercept header hash links for the contact page tabs
  document.addEventListener('DOMContentLoaded', function() {
    const contactTabsHashLinks = ['#lojista', '#atendimento-cliente', '#sou-nutricionista'];
    
    document.querySelectorAll('.header__inline-menu a, .header__submenu a, #HeaderMenu-MenuList-2 a').forEach(function(link) {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (!href) return;
        
        // Find matching hash
        const matchedHash = contactTabsHashLinks.find(hash => href.endsWith(hash) || href.includes(hash + '?') || href.includes(hash + '&'));
        if (matchedHash) {
          e.preventDefault();
          
          let tab = 'lojista';
          if (matchedHash === '#atendimento-cliente') tab = 'atendimento';
          if (matchedHash === '#sou-nutricionista') tab = 'nutri';
          
          if (window.location.pathname.includes('/pages/contato')) {
            // Already on contact page, activate tab
            const tabBtn = document.querySelector(`.contact-tab-btn[data-tab="${tab}"]`);
            if (tabBtn) {
              tabBtn.click();
              const wrapper = document.querySelector('.contact-tabs-wrapper');
              if (wrapper) {
                wrapper.scrollIntoView({ behavior: 'smooth' });
              }
            }
            window.location.hash = matchedHash;
          } else {
            // Redirect to contact page with the hash
            window.location.href = '/pages/contato' + matchedHash;
          }
        }
      });
    });
  });
})();
